import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BaseURL from '../../../assets/contants/BaseURL';

const DEMO_ALERTS = [
    { level: 'critical', message: 'GT3_EMS3 offline', time: '2m ago' },
    { level: 'warning', message: 'Voltage imbalance on Phase Y', time: '18m ago' },
    { level: 'info', message: 'Scheduled maintenance completed', time: '1h ago' },
];

const LEVEL_COLOR = { critical: '#d03b3b', warning: '#fab219', info: '#2a78d6', good: '#0ca30c' };

const AlertFeedWidget = ({ config }) => {
    const { dataSource = {} } = config;
    const [remoteAlerts, setRemoteAlerts] = useState(null);

    useEffect(() => {
        if (!dataSource.endpoint) return;
        let cancelled = false;
        const token = sessionStorage.getItem('token');

        axios.get(`${BaseURL}${dataSource.endpoint}`, {
            headers: { Authorization: `Token ${token}` },
        })
            .then((res) => { if (!cancelled) setRemoteAlerts(res.data?.alerts || null); })
            .catch((err) => console.error('AlertFeedWidget: failed to fetch', err));

        return () => { cancelled = true; };
    }, [dataSource.endpoint]);

    const alerts = remoteAlerts || DEMO_ALERTS;

    return (
        <div className="alert-feed-widget">
            {alerts.map((a, i) => (
                <div className="alert-feed-widget__row" key={i}>
                    <span className="alert-feed-widget__dot" style={{ backgroundColor: LEVEL_COLOR[a.level] || '#9ca3af' }} />
                    <div className="alert-feed-widget__body">
                        <div className="alert-feed-widget__message">{a.message}</div>
                        <div className="alert-feed-widget__time">{a.time}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AlertFeedWidget;
